import React from 'react';

const CustomerItem = ({ value, index }) => {
    const imgSet = `/partner/${value}.png, /partner/${value}@2x.png, /partner/${value}@3x.png`;
    const imgSrc = `/partner/${value}@3x.png`;
    return <img className="col img-fluid second" key={index} srcSet={imgSet} src={imgSrc} alt={value} />
}

export default CustomerItem;